'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import * as CustomPropTypes from '../../../../constants/PropTypes';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import * as Sync from 'ecosystem-marketplace-core/constants/dataSyncs/Sync';
import { getDataSyncFilterI18nKey } from '../../../../utils/i18n';
import RadioInput from '../inputs/RadioInput';
const ALL = 'ALL';
const dataSyncsOrder = Immutable.OrderedSet([ALL, Sync.INBOUND, Sync.OUTBOUND, Sync.BOTH]);

const _getDataSyncFilterI18nKey = sync => {
  switch (sync) {
    case ALL:
      return 'appMarketplace.storefront.filters.sync.items.all';

    default:
      return getDataSyncFilterI18nKey(sync);
  }
};

const DataSyncDirectionToggleGroup = ({
  onChange,
  value
}) => /*#__PURE__*/_jsx(UIToggleGroup, {
  name: "data-syncs",
  children: dataSyncsOrder.map(sync => /*#__PURE__*/_jsx(RadioInput, {
    checked: value ? value === sync : sync === ALL,
    onChange: ({
      target: {
        value: inputValue
      }
    }) => {
      onChange(inputValue === ALL ? null : inputValue);
    },
    value: sync,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: _getDataSyncFilterI18nKey(sync)
    })
  }, sync))
});

DataSyncDirectionToggleGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: CustomPropTypes.dataSyncDirection
};
export default DataSyncDirectionToggleGroup;